/**
 * Winnstech complete online handset prices.
 * These replace the former deposit + collection-balance model and include the
 * owner-approved additional 10% online-price increase applied on 16 October
 * 2026. Product pages also refresh against Shopify's live product endpoint.
 */
window.WinnstechPricing = Object.freeze({
  'iPhone 12 Pro Max': {'128GB':217.80,'256GB':251.68,'512GB':290.40},
  'iPhone 12 Pro': {'128GB':169.40,'256GB':212.96,'512GB':242.00},
  'iPhone 12 Mini': {'64GB':124.63,'128GB':143.99,'256GB':153.67},
  'iPhone 12': {'64GB':134.31,'128GB':158.51,'256GB':197.23},
  'iPhone 13 Pro Max': {'128GB':323.07,'256GB':356.95,'512GB':410.19,'1TB':458.59},
  'iPhone 13 Pro': {'128GB':278.30,'256GB':317.02,'512GB':341.22,'1TB':379.94},
  'iPhone 13 Mini': {'128GB':183.92,'256GB':212.96,'512GB':246.84},
  'iPhone 13': {'128GB':214.17,'256GB':272.25,'512GB':320.65},
  'iPhone 14': {'128GB':248.05,'256GB':310.97,'512GB':330.33},
  'iPhone 14 Pro Max': {'128GB':401.72,'256GB':454.96,'512GB':488.84,'1TB':527.56},
  'iPhone 14 Pro': {'128GB':327.91,'256GB':385.99,'512GB':410.19,'1TB':448.91},
  'iPhone 14 Plus': {'128GB':262.57,'256GB':315.81,'512GB':344.85},
  'iPhone 15 Pro Max': {'256GB':544.50,'512GB':784.08,'1TB':837.32},
  'iPhone 15 Pro': {'128GB':450.12,'256GB':503.36,'512GB':542.08,'1TB':566.28},
  'iPhone 15 Plus': {'128GB':395.67,'256GB':448.91,'512GB':473.11},
  'iPhone 15': {'128GB':356.95,'256GB':429.55,'512GB':448.91},
  'iPhone 16 Pro Max': {'256GB':703.25,'512GB':854.26,'1TB':892.98},
  'iPhone 16 Pro': {'128GB':574.99,'256GB':667.92,'512GB':740.52,'1TB':793.76},
  'iPhone 16 Plus': {'128GB':510.62,'256GB':578.38,'512GB':626.78},
  'iPhone 16': {'128GB':490.05,'256GB':572.33,'512GB':596.53},
  'iPhone Air': {'256GB':667.92,'512GB':740.52,'1TB':793.76},
  'iPhone 17 Pro Max': {'256GB':871.20,'512GB':992.20,'1TB':1079.32,'2TB':1156.76},
  'iPhone 17 Pro': {'256GB':801.02,'512GB':868.78,'1TB':931.70},
  'iPhone 17': {'256GB':641.30,'512GB':689.70}
});
